import type { Player } from "../types";

interface Props {
  player: Player;
  size?: number;
}

export function PlayerAvatar({ player, size = 44 }: Props) {
  const initial = player.name.trim().slice(0, 1).toUpperCase() || "?";
  const ringClass = player.cosmetics.catnipPack ? "avatar avatar-gold" : "avatar";
  const style = { width: size, height: size, fontSize: size * 0.42 };

  if (player.avatar) {
    return (
      <div className={ringClass} style={style}>
        <img src={player.avatar} alt={player.name} />
      </div>
    );
  }
  const hue = hashHue(player.id);
  return (
    <div
      className={ringClass}
      style={{ ...style, background: `hsl(${hue} 70% 45%)` }}
    >
      {initial}
    </div>
  );
}

function hashHue(s: string): number {
  let h = 0;
  for (const c of s) h = (h * 31 + c.charCodeAt(0)) % 360;
  return h;
}
